module.exports = __webpack_public_path__ + "img/edit-person-tag.72d9d968.png";